<!-- LOCATE DRIVERS COMPONENT -->
<div class="locate-drivers-component">
    <div class="locate-container">

        <!-- PAGE HEADER REMOVED: Moved Refresh button to main Header component to increase Map Height -->
        <div class="content-layout">
            <!-- LEFT COLUMN: MAP -->
            <div class="map-column">
                <div class="map-card">
                    <div class="map-wrapper">
                        <!-- FLOATING FILTERS OVERLAY (Now dynamically projected into map) -->

                        <app-reusable-google-map [isComponent]="true" [key]="mapKey" [locatedriver]="true"
                            (driversUpdated)="updateDriverCounts($event)"
                            (refreshLocationClicked)="openSendNotificationDialog('500ms','500ms')"
                            [filterType]="activeFilter">
                            
                            <div map-filters class="filters-overlay">
                                <div *ngIf="!isLoading; else chipsSkeleton" class="filters-row">
                                    <div class="filter-chip" [class.active]="activeFilter === 'all'"
                                        (click)="filterDrivers('all')">
                                        All Drivers
                                        <span class="count">{{ driverCounts.all }}</span>
                                    </div>
                                    <div class="filter-chip" [class.active]="activeFilter === 'online'"
                                        (click)="filterDrivers('online')">
                                        Online
                                        <span class="count">{{ driverCounts.online }}</span>
                                    </div>
                                    <div class="filter-chip" [class.active]="activeFilter === 'offline'"
                                        (click)="filterDrivers('offline')">
                                        Offline
                                        <span class="count">{{ driverCounts.offline }}</span>
                                    </div>
                                </div>

                                <ng-template #chipsSkeleton>
                                    <div class="filters-row">
                                        <div class="skeleton-chip skeleton-block" *ngFor="let i of [1,2,3]"></div>
                                    </div>
                                </ng-template>
                            </div>
                            
                        </app-reusable-google-map>
                    </div>
                </div>
            </div>

            <!-- RIGHT COLUMN: DRIVER LIST -->


        </div>
        <!-- END TWO COLUMN LAYOUT -->

    </div>
</div>
<!-- END LOCATE DRIVERS COMPONENT -->